import { Tooltip } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";
import { useTeamSummaryStyles } from "./TeamSummary.styles";
import { ITeamSummaryProps } from "./TeamSummary.types";

const AVATAR_COLORS = [
  designTokens.primary[500],
  designTokens.semantic.success,
  designTokens.accent[500],
  designTokens.semantic.info,
  designTokens.semantic.error,
  designTokens.semantic.warning,
];

export const getTeamAvatarColor = (index: number): string =>
  AVATAR_COLORS[index % AVATAR_COLORS.length];

const getInitials = (name: string): string => name.slice(0, 2).toUpperCase();

export const TeamSummary = ({
  team,
  avatarColor,
}: ITeamSummaryProps): JSX.Element => {
  const styles = useTeamSummaryStyles();

  return (
    <span className={styles.teamSummary}>
      <span
        className={styles.teamAvatar}
        style={{
          color: avatarColor,
          backgroundColor: `${avatarColor}1A`,
        }}
        aria-hidden="true"
      >
        {getInitials(team.name)}
      </span>
      <span className={styles.teamMeta}>
        <span className={styles.teamNameRow}>
          <Tooltip content={team.name} relationship="description" withArrow>
            <span className={styles.teamName}>{team.name}</span>
          </Tooltip>
        </span>
        <span className={styles.teamDetails}>
          {team.memberCount} members · Owner {team.ownerName}
        </span>
      </span>
    </span>
  );
};
